import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthGate } from "./components/auth/AuthGate";
import { ShellPage } from "./pages/Shell";

/** Stessa istanza React su /, /w/:id, /s/:id — niente layout annidato con index vuoto. */
const authedShell = (
  <AuthGate>
    <ShellPage />
  </AuthGate>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={authedShell} />
        <Route path="/inbox" element={authedShell} />
        <Route path="/favorites" element={authedShell} />
        <Route path="/shared" element={authedShell} />
        <Route path="/board" element={authedShell} />
        <Route path="/account" element={authedShell} />
        <Route path="/activity" element={authedShell} />
        <Route path="/w/:waveId" element={authedShell} />
        <Route path="/s/:spaceId" element={authedShell} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
